var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"txt-center"},[_vm._v("페이지를 불러오는 중입니다...")])])
}]

export { render, staticRenderFns }